import React, { useState, useEffect } from "react";
import { FaEdit } from "react-icons/fa";
import {
  getAllClients,
  registerClient,
  updateClient,
  toggleClientStatus
} from "../../services/clientService";
import { toast } from "react-toastify";

const ClientList = () => {
  const [clients, setClients] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    labName: "",
    domain: "",
    mobile: "",
    email: "",
    patientCount: "",
    status: "",
  });

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const res = await getAllClients();

      console.log("API RESPONSE:", res);

      // Handle all possible structures safely
      const clientData =
        res?.data?.data ||
        res?.data ||
        res ||
        [];

      setClients(Array.isArray(clientData) ? clientData : []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load clients");
      setClients([]); // fallback safety
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ADD / UPDATE
  const handleSave = async () => {
    if (!form.labName || !form.mobile || !form.email) {
      toast.warning("Lab Name, Mobile and Email are required");
      return;
    }

    try {
      if (editId) {
        await updateClient(editId, {
          name: form.labName,
          email: form.email,
          password: "password123",
          mobile: form.mobile,
          client_name: form.labName,
          client_domain: form.domain,
        });

        toast.success("Client updated successfully");
      } else {
        await registerClient({
          name: form.labName,
          email: form.email,
          password: "Demo123",
          password_confirmation: "Demo123",
          mobile: form.mobile,
          created_by: "system",
          client_name: form.labName,
          client_domain: form.domain,
        });

        toast.success("Client created successfully");
      }

      fetchClients();

      setForm({
        labName: "",
        domain: "",
        mobile: "",
        email: "",
        patientCount: "",
        status: "",
      });

      setShowModal(false);
      setEditId(null);

    } catch (err) {
      console.error(err);
      toast.error(err?.message || err?.error || "Something went wrong");
    }
  };

  // EDIT
  const handleEdit = (item) => {
    setForm({
      labName: item.client_name || item.client?.name || item.name,
      domain: item.client_domain || item.client?.domain || "",
      mobile: item.mobile,
      email: item.email,
      patientCount: "",
      status: item.role,
    });

    setEditId(item.id);
    setShowModal(true);
  };

  const handleToggleStatus = async (id) => {
    try {
      const res = await toggleClientStatus(id);

      if (res.status === 200) {
        toast.success(res.message || "Status updated");

        // Refresh list after toggle
        fetchClients();
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.message || "Failed to update status");
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h2 style={styles.heading}>Client List</h2>

        <button style={styles.addBtn} onClick={() => setShowModal(true)}>
          + Add
        </button>
      </div>

      {/* Table */}
      <div style={styles.card}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.theadRow}>
              <th>Lab Name</th>
              <th>Domain</th>
              <th>Mobile No.</th>
              <th>Email</th>
              <th>Pt.Count</th>
              <th>Registered</th>
              <th>Status</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>

          <tbody>
            {clients.length === 0 ? (
              <tr>
                <td colSpan="8" style={styles.empty}>
                  No Clients Found
                </td>
              </tr>
            ) : (
              clients.map((item) => (
                <tr key={item.id} style={styles.row}>

                  {/* Lab Name */}
                  <td>{item.client?.name || item.name}</td>

                  {/* Domain */}
                  <td>{item.client?.domain || "-"}</td>

                  {/* Mobile */}
                  <td>{item.mobile}</td>

                  {/* Email */}
                  <td>{item.email}</td>

                  {/* Patient Count */}
                  <td>-</td>

                  {/* Registered Date */}
                  <td>
                    {new Date(item.created_at).toLocaleDateString()}
                  </td>

                  {/* Status */}
                  <td>
                    <span
                      onClick={() => handleToggleStatus(item.client.id)}
                      style={{
                        padding: "4px 10px",
                        borderRadius: "20px",
                        color: "#fff",
                        background:
                          item.client?.status === "1"
                            ? "#1ab394"
                            : "#ed5565",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    >
                      {item.client?.status === "1"
                        ? "Active"
                        : "Inactive"}
                    </span>
                  </td>

                  {/* Action */}
                  <td style={styles.actionCell}>
                    <button
                      style={styles.editBtn}
                      onClick={() => handleEdit(item)}
                    >
                      <FaEdit />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>{editId ? "Update Client" : "Add Client"}</h3>

            <input
              name="labName"
              placeholder="Lab Name"
              value={form.labName}
              onChange={handleChange}
              style={styles.input}
            />

            <input
              name="domain"
              placeholder="Domain"
              value={form.domain}
              onChange={handleChange}
              style={styles.input}
            />

            <input
              name="mobile"
              placeholder="Mobile No."
              value={form.mobile}
              onChange={handleChange}
              style={styles.input}
            />

            <input
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              style={styles.input}
            />

            <div style={styles.modalActions}>
              <button
                style={styles.cancelBtn}
                onClick={() => {
                  setShowModal(false);
                  setEditId(null);
                }}
              >
                Cancel
              </button>

              <button style={styles.saveBtn} onClick={handleSave}>
                {editId ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientList;

/* STYLES */
const styles = {
  container: { padding: "10px" },

  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px",
  },

  heading: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#2f4050",
  },

  addBtn: {
    background: "#1c84c6",
    color: "#fff",
    padding: "8px 14px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },

  editBtn: {
    background: "#1c84c6",
    border: "none",
    color: "#fff",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  card: {
    background: "#fff",
    borderRadius: "10px",
    padding: "15px",
  },

  table: { width: "100%", borderCollapse: "collapse" },

  theadRow: { background: "#f5f7fa" },

  row: { borderBottom: "1px solid #eee" },

  empty: { textAlign: "center", padding: "20px", color: "#888" },

  actionCell: {
    textAlign: "center",
  },

  iconBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  modal: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "350px",
  },

  input: {
    width: "100%",
    marginBottom: "10px",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },

  modalActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },

  cancelBtn: {
    background: "#ccc",
    border: "none",
    padding: "6px 12px",
    borderRadius: "5px",
    cursor: "pointer",
  },

  saveBtn: {
    background: "#1ab394",
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    borderRadius: "5px",
    cursor: "pointer",
  },
};